<template>
  <div class="green__admin green__column green__100">
    <!-- <a @click="logout" class="green__logout">Выйти</a>
         -->
    <div class="item__row item__ac item__jb item__90 bonus__actions" v-if="page === 6">
      <div class="bonus__actions__btn item__abs" @click="openModal()">
        <i class="mdi mdi-account-multiple-plus"></i>
      </div>
      <div class="bonus__actions__btn item__abs" @click="openModalAddBonus()">
        <i class="mdi mdi-cash-plus"></i>
      </div>
      <div class="bonus__actions__btn item__abs" @click="openModalUseBonus()">
        <i class="mdi mdi-cash-minus"></i>
      </div>
      <!-- <p class="create__bonus mr-2 item__pointer" @click="openModal()" >Открыть бонусную карту</p>
                <p class="add__bonus mr-2 item__pointer" @click="openModalAddBonus()" >Добавить бонус</p>
                <p class="use__bonus item__pointer" @click="openModalUseBonus()" >Списать бонус</p>
        -->
    </div>
    <i class="mdi mdi-logout" @click="logout"></i>
    <div class="green__row green__100 green__admin__inner">
      <div class="green__left green__column">
        <div
            v-bind:class="{ green__active: $route.path === '/admin' }"
            class="pa-2 green__row green__ac green__mb__s green__btn">
          <i
              class="fas fa-directions green__mr__xs"
          ></i>
          <p @click="$router.push('/admin')">
            Категории
          </p>
        </div>

        <div
            v-bind:class="{ green__active:  $route.path === '/products' }"
            class="pa-2 green__row green__ac green__mb__s green__btn">
          <i
              class="mdi mdi-package-variant"
          ></i>

          <p @click="$router.push('products')">
            Добавить товар
          </p>

        </div>

        <div
            v-bind:class="{ green__active:  $route.path === '/list-products' }"
            class="pa-2 green__row green__ac green__mb__s green__btn">
          <i
              class="mdi mdi-package-variant"
          ></i>

          <p @click="$router.push('list-products')">
            Список товаров
          </p>

        </div>


        <div
            v-bind:class="{ green__active: $route.path === '/orders' }"
            class="pa-2 green__row green__ac green__mb__s green__btn">
          <i class="mdi mdi-reorder-horizontal"></i>
          <p @click="$router.push('orders')">
            Заказы
          </p>
        </div>

<!--        <div-->
<!--            v-bind:class="{ green__active: $route.path === '/sliders' }"-->
<!--            class="pa-2 green__row green__ac green__mb__s green__btn"-->
<!--        >-->
<!--          <i-->
<!--              class="mdi mdi-layers"-->
<!--          ></i>-->
<!--          <p @click="$router.push('sliders')">-->
<!--            Баннеры-->
<!--          </p>-->
<!--        </div>-->

      </div>


      <div class="green__right green__100">
        <router-view></router-view>
      </div>
    </div>

    <v-alert
        class="green__notif_position"
        type="success"
        :value="savedData"
        transition="fade-transition"
    >
      {{ message_notif }}
    </v-alert
    >

    <v-row justify="center">
      <v-dialog v-model="dialog" max-width="400">
        <v-card>
          <v-card-title class="headline" v-if="delete_type == 1">
            Удалить запись?<br/>
            (Если удалить данную категорию удаляеся все дочерный категорий и товары)
          </v-card-title>
          <v-card-title class="headline" v-else> Удалить запись?</v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="dialog = false"> Нет</v-btn>
            <v-btn
                color="green darken-1"
                text
                @click="deleteProcess(delete_type, delete_index, type_category)"
            >
              Да
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogApplication" max-width="500">
        <v-card>
          <v-card-title class="headline">
            <div class="green__row green__ac green__jb green__100">
              <p>Форма</p>
              <p @click="dialogApplication = false">Закрыть</p>
            </div>
          </v-card-title>

          <form
              action=""
              @submit.prevent="acceptApplication"
              class="green__column green__message"
              style="padding: 20px"
          >
            <div class="green__column green__input">
              <p>Сообщение на почту</p>
              <v-text-field
                  v-model="message"
                  label="Сообщение"
                  required
                  outlined
              ></v-text-field>
            </div>
            <button type="submit">Отправить</button>
          </form>
        </v-card>
      </v-dialog>
    </v-row>

    <v-dialog max-width="600" v-model="use_modal_create">
      <v-card>
        <div class="pa-5 item__column modal__bonus">
          <p class="modal__bonus__title">Cоздать бонусную карту</p>
          <div class="item__column modal__bonus__label">
            <p>Имя владельца</p>
            <input v-model="name_owner"/>
          </div>

          <div class="item__column modal__bonus__label">
            <p>Телефон</p>
            <masked-input
                class="sms__digits"
                placeholder="8 XXX XXX XX XX"
                v-model.trim="phone_number"
                mask="8(111) 111-11-11"
            />
          </div>

          <!--          <div class="item__column modal__bonus__label">-->
          <!--            <p>Номер карты</p>-->
          <!--            <input v-model="card_number" type="number" />-->
          <!--          </div>-->

          <StreamBarcodeReader
              v-if="openScaner"
              @decode="onDecode"
              @loaded="onLoaded"
          ></StreamBarcodeReader>

          <div class="item__column modal__bonus__label">
            <p>Сумма заказа</p>
            <input v-model="amount_price" type="number"/>
          </div>

          <!--          <button-->
          <!--              type="submit"-->
          <!--              class="modal__bonus__btn item__row item__ac item__pointer mb-3"-->
          <!--              @click="openScaner = true"-->
          <!--          >-->
          <!--            <i class="mdi mdi-camera-outline mr-2"></i>-->
          <!--            <p>Сканировать</p>-->
          <!--          </button>-->

          <button
              type="submit"
              class="modal__bonus__btn item__pointer"
              @click="createBonus"
          >
            <p>Создать бонусный счет</p>
          </button>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog max-width="600" v-model="use_modal_add">
      <v-card>
        <div class="pa-5 item__column modal__bonus">
          <p class="modal__bonus__title">Добавить бонус</p>

          <div class="item__row item__ac modal__bonus__result">
            <p>{{ bonus }}</p>
          </div>

          <div class="item__column modal__bonus__label">
            <p>Телефон</p>
            <masked-input
                class="sms__digits"
                v-model.trim="phone_number"
                mask="8(111) 111-11-11"
            />
          </div>
          <!--          <div class="item__column modal__bonus__label">-->
          <!--            <p>Номер карты</p>-->
          <!--            <input v-model="card_number" @input="changeCard" type="number" />-->
          <!--          </div>-->

          <StreamBarcodeReader
              v-if="openScaner"
              @decode="onDecode"
              @loaded="onLoaded"
          ></StreamBarcodeReader>

          <div class="item__column modal__bonus__label">
            <p>Сумма заказа</p>
            <input v-model="amount_price" type="number"/>
          </div>

          <!--          <button-->
          <!--              type="submit"-->
          <!--              class="modal__bonus__btn item__row item__ac item__pointer mb-3"-->
          <!--              @click="openScaner = true"-->
          <!--          >-->
          <!--            <i class="mdi mdi-camera-outline mr-2"></i>-->
          <!--            <p>Сканировать</p>-->
          <!--          </button>-->

          <button
              type="submit"
              class="modal__bonus__btn item__pointer"
              @click="addBonus()"
          >
            <p>Добавить бонус</p>
          </button>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog max-width="600" v-model="use_modal_bonus">
      <v-card>
        <div class="pa-5 item__column modal__bonus">
          <p class="modal__bonus__title">Списать бонус</p>
          <div class="item__row item__ac modal__bonus__result">
            <p class="mb-2 mt-3">{{ bonus }}</p>
          </div>
          <div class="item__column modal__bonus__label">
            <p>Телефон</p>
            <masked-input
                class="sms__digits"
                v-model.trim="phone_number"
                mask="8(111) 111-11-11"
            />
          </div>
          <!--          <div class="item__column modal__bonus__label">-->
          <!--            <p>Номер карты</p>-->
          <!--            <input v-model="card_number" />-->
          <!--            <span style="color: gray">Не обязательно к заполнению</span>-->
          <!--          </div>-->

          <div class="item__column modal__bonus__label">
            <p>Сумма к списанию</p>
            <input v-model="sub_amount" required/>
          </div>

          <StreamBarcodeReader
              v-if="openScaner"
              @decode="onDecode"
              @loaded="onLoaded"
          ></StreamBarcodeReader>

          <!--          <button-->
          <!--              type="submit"-->
          <!--              class="modal__bonus__btn item__row item__ac item__pointer mb-3"-->
          <!--              @click="openScaner = true"-->
          <!--          >-->
          <!--            <i class="mdi mdi-camera-outline mr-2"></i>-->
          <!--            <p>Сканировать</p>-->
          <!--          </button>-->
          <button
              type="submit"
              class="modal__bonus__btn item__pointer"
              @click="useBonus()"
          >
            <p>Списать бонус</p>
          </button>
        </div>
      </v-card>
    </v-dialog>


  </div>
</template>

<script>
import MaskedInput from "vue-masked-input";
import {StreamBarcodeReader} from "vue-barcode-reader";

export default {
  components: {
    MaskedInput,
    StreamBarcodeReader,
  },
  data() {
    return {
      openHeightModal: false,
      openSizeModal: false,
      current_category_index: 0,
      showProduct: false,
      showLoader: true,
      openScaner: false,
      type_category: "",
      name_owner: "",
      createLoader: false,
      bonus_not_found: "",
      bonus: "",
      use_modal_create: false,
      use_modal_add: false,
      use_modal_bonus: false,

      card_number: "",
      amount_price: "",
      phone_number: "",
      modal: false,
      all_categories: [],
      category_id: "",
      choosen_type: "",
      showSkeleton: false,
      category_type: null,
      documents: [],
      rules: {
        select: [(v) => !!v || "Выберите категорию"],
        select2: [(v) => v.length > 0 || "Item is required in select 2"],
      },
      name: null,
      price: null,
      count: null,
      articul: null,
      message_notif: null,
      dialogApplication: false,
      dialog: false,
      savedData: false,
      seeСategory: false,
      seePurchase: false,
      cat: null,
      title: "",
      description: "",
      priority: 0,
      category_name: "",
      page: 1,
      token: "",
      categories: [],
      user: {
        role: "",
      },
      delete_index: "",
      delete_type: "",
      document: null,
      applications: [],
      application_index: null,
      purchase_index: null,
      message: "Здравствуйте,",
      products: [],
      orders: [],
      page_category: 1,
      nested: [],
      p_id: "",
      parent_category_name: null,
      category_for_product: null,
      selected_category: null,
      category_name_edit: "",
      category_id_edit: null,
      banners: [],
      banner_images: [],
      category: {
        image: "",
      },
      bonusesList: [],
      sub_amount: "",
      params: []
    };
  },
  computed: {
    filteredData(key) {
      return this.categories.filter((item) => item.id === key);
    },
  },
  watch: {
    phone_number(val) {
      if (val.replace(/[^0-9]/g, "").length == 11) {
        this.getBonus();
      }
    },
    card_number() {
      // if(val.replace(/[^0-9]/g,"").length==9) {
      this.getBonus();
      // }
    },
  },
  methods: {
    getParams() {
      const config = {
        headers: {Authorization: `Bearer ${localStorage.getItem('access_token')}`},
      };
      this.$http.get("/params", config).then((res) => {
        this.params = res.data;
      });
    },
    changeCard() {
      // if(this.card_number.replace(/[^0-9]/g,"").length==9) {
      //     this.getBonus();
      // }
    },
    onDecode(result) {
      this.openScaner = false;
      this.card_number = result;
      //   }
    },
    onLoaded(result) {
      console.log("ready");
      console.log(result);
    },
    createBonus() {
      if (this.phone_number.replace(/[^0-9]/g, "").length < 11) {
        this.$toast.open({
          message: "Поле телефон не правильно заполнено",
          type: "warning",
          position: "bottom",
          duration: 5000,
          queue: true,
        });
      }
      //  if(this.phone_number.replace(/[^0-9]/g,"").length<8) {
      //   this.$toast.open({
      //     message: 'Поле номер карты не правильно заполнено',
      //     type: 'warning',
      //     position: 'bottom',
      //     duration: 5000,
      //     queue: true
      //   });
      // }
      if (this.name_owner == "") {
        this.$toast.open({
          message: "Заполните поле имя",
          type: "warning",
          position: "bottom",
          duration: 5000,
          queue: true,
        });
      }
      let data = {
        name: this.name_owner,
        phone: this.phone_number.replace(/[^0-9]/g, ""),
        amount: this.amount_price,
        card_number: this.card_number,
      };
      this.$http
          .post("/create/bonus", data, {
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
          })
          .then((res) => {
            this.$toast.open({
              message: res.data.message,
              type: "warning",
              position: "bottom",
              duration: 5000,
              queue: true,
            });
            this.use_modal_create = false;
            this.phone_number = "";
            this.name_owner = "";
            this.amount_price = "";

            this.$refs.bonusesList.getBonuses();
            this.$refs.bonusesList.getGuest();
          })
          .catch((error) => {
            this.$toast.open({
              message: error.response.data.error,
              type: "error",
              position: "bottom",
              duration: 5000,
              queue: true,
            });
          });
    },
    getBonuses() {
      const config = {
        headers: {Authorization: `Bearer ${localStorage.getItem("access_token")}`},
      };
      this.bonus = "";
      this.$http.get("/get/bonuses", config).then((res) => {
        this.bonusesList = res.data;
      });
    },
    addBonus() {
      // if(this.phone_number.replace(/[^0-9]/g,"").length<11) {
      //   this.$toast.open({
      //     message: 'Поле телефон не правильно заполнено',
      //     type: 'warning',
      //     position: 'bottom',
      //     duration: 5000,
      //     queue: true
      //   });
      // }

      if (this.amount == "") {
        this.$toast.open({
          message: "Заполните поле сумма",
          type: "warning",
          position: "bottom",
          duration: 5000,
          queue: true,
        });
      }

      let data = {
        phone: this.phone_number.replace(/[^0-9]/g, ""),
        amount: this.amount_price,
        card_number: this.card_number,
      };

      this.use_modal_add = false;

      this.$http
          .post("/add/bonus", data, {
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
          })
          .then((res) => {
            console.log(res);

            this.$toast.open({
              message: "Бонус успешно добавлено",
              type: "warning",
              position: "bottom",
              duration: 5000,
              queue: true,
            });
            this.$refs.bonusesList.getBonuses();
            this.$refs.bonusesList.getGuest();
            this.phone_number = "";
            this.amount = "";
          })
          .catch((error) => {
            this.$toast.open({
              message: error.response.data.error,
              type: "error",
              position: "bottom",
              duration: 5000,
              queue: true,
            });
          });
    },
    useBonus() {
      if (this.phone_number.replace(/[^0-9]/g, "").length != 11) {
        this.$toast.open({
          message: "Введите телефон",
          type: "error",
          position: "bottom",
          duration: 5000,
          queue: true,
        });
      } else if (!this.sub_amount) {
        this.$toast.open({
          message: "Введите сумму к списанию",
          type: "error",
          position: "bottom",
          duration: 5000,
          queue: true,
        });
      }

      this.use_modal_bonus = false;
      let data = {
        phone: this.phone_number.replace(/[^0-9]/g, ""),
        card_number: this.card_number,
        sub_amount: this.sub_amount,
      };
      this.$http
          .post("/use/bonus", data, {
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
          })
          .then((res) => {
            this.$toast.open({
              message: res.data.message,
              type: "warning",
              position: "bottom",
              duration: 5000,
              queue: true,
            });
            this.$refs.bonusesList.getBonuses();
            this.$refs.bonusesList.getGuest();
          })
          .catch((error) => {
            this.$toast.open({
              message: error.response.data.error,
              type: "error",
              position: "bottom",
              duration: 5000,
              queue: true,
            });
          });
    },
    openModal() {
      this.use_modal_create = true;
    },
    openModalAddBonus() {
      this.phone_number = "";
      this.bonus = "";
      this.use_modal_add = true;
    },
    getBonus() {
      const config = {
        headers: {Authorization: `Bearer ${this.token}`},
      };
      this.bonus = "";
      this.$http
          .get(
              "/get/auth/bonus?phone=" +
              this.phone_number.replace(/[^0-9]/g, "") +
              "&card_number=" +
              this.card_number,
              config
          )
          .then((res) => {
            if (res.data.bonus) {
              if (res.data.bonus == "zero") {
                this.bonus = "0 тг";
              } else {
                this.bonus = "Накоплено: " + res.data.bonus + " тг";
              }
            } else {
              this.bonus = res.data.message;
            }
          });
    },
    openModalUseBonus() {
      this.phone_number = "";
      this.bonus = "";
      this.use_modal_bonus = true;
    },
    openPage(type) {
      this.page = type;

      this.nested = [];
    },
    chooseCategoryForProduct(id, type) {
      this.category_id = id;
      let t = "";
      if (type == "child") {
        t = this.nested.filter((item) => item.id === id);
      } else {
        t = this.categories.filter((item) => item.id === id);
      }
      this.category_for_product = t[0].name;
    },
    chooseParentMain(type) {
      this.nested = [];
      this.page_category = type;
      this.p_id = "";

      this.getCategories();
    },

    closeDialog() {
      this.dialogApplication = false;
    },

    okApplication(app_id, purchase_id) {
      this.application_index = app_id;
      this.purchase_index = purchase_id;
      this.dialogApplication = true;
    },
    acceptApplication() {
      this.dialogApplication = false;

      let data = {
        message: this.message,
        purchase_id: this.purchase_index,
        id: this.application_index,
      };
      this.$http
          .post("/accept/application", data, {
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
          })
          .then((res) => {
            this.purchase_index = null;
            this.application_index = null;
            this.message_notif = res.data.message;
            this.savedData = true;
            this.getCategories();
            window.setInterval(() => {
              this.savedData = false;
            }, 4000);
          });
    },
    downloadDoc(link) {
      window.open("https://api.greenclinic.kz" + link, "_blank");
    },
    uploadCategoryImage(e) {
      const file = e.target.files[0];
      this.category.image = file;
    },
    logout() {
      localStorage.removeItem("access_token");
      this.$router.push("/");
    },
    editCategory(index) {
      this.categories[index].edit = !this.categories[index].edit;
      let p = this.categories;
      this.categories = [];
      this.categories = p;
    },
    getCategories() {
      const config = {
        headers: {Authorization: `Bearer ${this.token}`},
      };
      this.$http.get("/get/categories", config).then((res) => {
        this.categories = res.data;
      });
    },



    deleteProcess(index, id, type_category) {
      this.dialog = false;
      let type = "category";
      if (index == 2) {
        type = "product/admin";
      }
      if (index == 3) {
        type = "application";
      }
      if (index == 4) {
        type = "product/image";
      }

      const config = {
        headers: {Authorization: `Bearer ${this.token}`},
      };
      this.$http.get("/delete/" + type + "?id=" + id, config).then((res) => {
        this.products = res.data;
        this.message_notif = res.data.message;
        this.getCategories();
        this.getProductByCategory(this.category_id, type_category);
      });
    },
  },
  mounted() {
    this.getParams()
    if (localStorage.getItem("access_token")) {
      this.token = localStorage.getItem("access_token");
      this.$http
          .post(
              "/get/user/me",
              {},
              {
                headers: {
                  Authorization: `Bearer ${this.token}`,
                },
              }
          )
          .then((res) => {
            this.user.id = res.data.id;
            this.page = 1;
            this.user.role = res.data.name;
            this.user = res.data;
          });
    } else {
      this.$router.push("/login");
    }
  },
};
</script>
<style scoped lang="less">
.admin__loader {
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0;
  z-index: 10;
  bottom: 0;
  background-image: linear-gradient(to right,
  #253532,
  #1e363d,
  #273345,
  #3c2e43,
  #4c2934);

  i {
    font-size: 36px;
    color: white;
  }

  p {
    font-size: 36px;
    color: white;
  }
}

@mobile: 900px;
@planshet: 1200px;
.mdi-logout {
  font-size: 26px;
  position: absolute;
  right: 20px;
  color: white;
  top: 20px;
}

.bonus__actions {
  width: 100%;
  z-index: 10;
  position: fixed;
  background: #191a21;
  bottom: 0;
  padding: 20px;

  .bonus__actions__btn {
    i {
      color: white;
      font-size: 32px;
    }
  }

  // p {
  //     padding: 15px;
  //     background-image: linear-gradient(to right, #131215, #1d161e, #2b1824, #3a1924, #481b20);
  //     border-radius: 20px;
  //     color: white;
  //     text-align: center;
  //     font-weight: bold;
  //     cursor: pointer;
  //     @media (max-width: @mobile) {
  //        padding: 10px;
  //        font-size: 14px;
  //     }
  // }
}

.modal__bonus {
  .modal__bonus__title {
    font-size: 22px;
    font-weight: bold;
    text-align: center;
    color: #4c2934;
  }

  .modal__bonus__result {
    margin-bottom: 10px;

    p {
      font-size: 18px;
      color: #0069ff;

      span {
        font-weight: bold;

        font-size: 20px;
      }
    }
  }

  .modal__bonus__label {
    margin-bottom: 15px;
  }

  input {
    padding: 10px;
    outline: none;
    border: 1px solid #ccc;
  }

  .modal__bonus__btn {
    border-radius: 20px;
    padding: 20px;
    text-align: center;
    justify-content: center;
    background-image: linear-gradient(to right,
    #253532,
    #1e363d,
    #273345,
    #3c2e43,
    #4c2934);

    p {
      color: white;
      font-weight: bold;
    }

    i {
      color: white;
    }
  }
}


.green__active {
  background: #0069ff;
  color: white;

  i {
    color: white !important;
  }
}

.banners {
  overflow-x: scroll;

  i {
    cursor: pointer;
  }

  img {
    width: 100px;
    height: 100px;
    object-fit: cover;
  }
}

.green__notif_position {
  bottom: 200px;
}

p {
  margin-bottom: 0 !important;
}

.green__mb__xs {
  margin-bottom: 10px;
}

.green__mb__s {
  margin-bottom: 20px !important;
}

.green__ml__l {
  margin-left: 20px;
}

.green__mr__xs {
  margin-right: 10px;
}

.green__100 {
  width: 100%;
}

.green__row {
  display: flex;
  flex-direction: row;
}

.green__ac {
  align-items: center;
}

.green__jb {
  justify-content: space-between;
}

.green__column {
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
  @media (max-width: @mobile) {
    width: 100%;
  }
}

.green__abs {
  display: flex;
  justify-content: center;
  align-items: center;
}

.green__pointer {
  cursor: pointer;
}


.green__btn__color {
  color: #0069ff;
}

.green__btn__color:hover {
  opacity: 0.6;
}

.green__admin {
  min-height: 100vh;

  align-items: center;
  justify-content: center;

  .green__see {
    font-size: 18px;
    font-weight: bold;
    @media (max-width: 900px) {
      font-size: 12px;
      white-space: nowrap;
    }
  }

  .green__see--active {
    color: #0069ff;
  }

  .green__images__title {
    margin-top: 40px;
    color: #0069ff;
    font-size: 16px;
    font-weight: bold;
    text-transform: uppercase;
  }

  .green__product__images__main::-webkit-scrollbar {
    height: 5px;
  }

  .green__product__images__main::-webkit-scrollbar-track {
    border-radius: 2px;
    background-color: #ccc;
  }

  .green__product__images__main::-webkit-scrollbar-thumb {
    background-color: #0069ff;
    border-radius: 2px;
    height: 24px;
    width: 50px;
  }

  .green__product__images__main {
    overflow-x: auto;
    width: 50%;
  }

  .green__product__images {
    margin-bottom: 5px;
    margin-top: 5px;

    img {
      width: 70px;
      height: 70px;
      border-radius: 10px;
      object-fit: cover;
      margin-right: 30px;
    }
  }

  .green__logout {
    align-self: flex-end;
    padding: 10px;
    background-image: linear-gradient(to right,
    #253532,
    #1e363d,
    #273345,
    #3c2e43,
    #4c2934);
    color: white;
    margin-bottom: 20px;
    width: 140px;
    text-align: center;
  }

  .green__logout:hover {
    background: #5c8a0d;
  }

  .green__left {
    width: 20%;
    padding: 20px;
    background: #ffffff;
    box-shadow: 0px 8px 40px rgba(0, 0, 0, 0.05);
    border-radius: 2px;
    margin-right: 20px;
    min-height: 100px;

    @media (max-width: @mobile) {
      width: 100%;
      margin-left: 0;
      margin-bottom: 20px;
    }

    p {
      font-weight: bold;
      cursor: pointer;
    }

    i {
      color: black;
      margin-right: 10px;
      font-size: 22px;
    }
  }

  .green__right {
    padding: 20px;
    background: #ffffff;
    box-shadow: 0 8px 40px rgba(0, 0, 0, 0.05);
    border-radius: 10px;


    i {
      color: white;
    }

    .green__parents {
      p {
        font-size: 20px;
      }

      i {
        background: #0069ff;
        padding: 10px;
        font-size: 22px;
        border-radius: 50%;
        margin-right: 10px;
      }

      i:hover {
        opacity: 0.8;
      }
    }

    .green__choose {
      margin-bottom: 20px;

      .green__category__choose {
        cursor: pointer;
        padding: 20px;
        background: gray;
        margin-right: 10px;
        color: white;
        @media (max-width: @mobile) {
          font-size: 14px;
        }
        border-radius: 20px;
      }

      .green__category__active {
        background: #0069ff;
      }
    }

    .green__input {
      width: 300px;
      @media (max-width: @mobile) {
        width: 100%;
      }

      .green__input__write {
        border: 1px solid black;
        padding: 20px;
        border-radius: 2px;
        outline: none;
      }
    }

    button {
      width: 300px;
      outline: none;
      border: none;
      padding: 20px;
      box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px,
      rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px,
      rgba(0, 0, 0, 0.09) 0px -3px 5px;
      @media (max-width: @mobile) {
        width: 100%;
      }
    }

    .green__edit {
      margin-bottom: 20px;
      border-radius: 2px;
      border: 1px solid #ccc;
      padding: 20px;

      a {
        color: #0069ff !important;
      }

      .green__user__orders {
        margin-top: 30px;
        margin-left: 10px;

        .green__user__title {
          font-weight: bold;
          font-size: 18px;
        }
      }

      @media (max-width: @mobile) {
        margin-left: 0;
      }

      .green__last__action {
        p {
          font-size: 12px;
        }
      }

      .green__data {
        margin-bottom: 10px;
        color: #0069ff;
        font-size: 18px;
      }

      .green__save__btn {
        color: #0069ff;
      }

      button {
        width: 300px;
        outline: none;
        border: none;
        background-color: #0069ff;
        color: white;
        padding: 20px;
        @media (max-width: @mobile) {
          width: 100%;
        }
      }
    }
  }
}

.green__message {
  button {
    outline: none;
    border: none;
    background-color: #0069ff;
    color: white;
    padding: 20px;
  }
}

.green__admin__inner {
  @media (max-width: @mobile) {
    flex-direction: column;
  }
}
</style>
